// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "" + "70fdc007d3d9aebe7798" + ".js";
};